import { Button, DataGrid, Popup, ScrollView, Tabs } from 'devextreme-react';
import { Column } from 'devextreme-react/data-grid';
import React from 'react';
import moment from 'moment';

const CorpListUpdateInfoPopup = ({
  onHiding,
  onItemClick,
  updateInfo,
  updateUserInfoList,
  updateUserLimitInfoList,
  visibleUpdateInfoPopup,
  tabs,
}) => {
  // console.log('CorpListUpdateInfoPopup Load');

  return (
    <React.Fragment>
      <Popup
        title={
          '변경내역(' +
          (updateInfo.selectedIndex === 0
            ? updateUserInfoList.length
            : updateUserLimitInfoList.length) +
          '회)'
        }
        className="popup"
        maxHeight="40rem"
        visible={visibleUpdateInfoPopup}
        onHiding={onHiding}
      >
        <ScrollView>
          <div className="corp-list-update-info-content popup-content">
            <Tabs
              dataSource={tabs}
              selectedIndex={updateInfo.selectedIndex}
              onItemClick={onItemClick}
            />
            {updateInfo.selectedIndex === 0 ? (
              <div>
                <DataGrid
                  className={'dx-card wide-card'}
                  columnAutoWidth={true}
                  dataSource={updateUserInfoList}
                  focusedRowEnabled={true}
                  height="100%"
                  keyExpr="wDateTime"
                  noDataText="변경내역이 없습니다."
                  showBorders={true}
                  width="100%"
                >
                  <Column dataField="Name" caption="이름" alignment="center" />
                  <Column
                    dataField="CustomerTypeName"
                    caption="고객구분"
                    alignment="center"
                  />
                  <Column dataField="Part" caption="부서" alignment="center" />
                  <Column dataField="Duty" caption="직책" alignment="center" />
                  <Column
                    dataField="Dong"
                    caption="일반주소"
                    alignment="center"
                  />
                  <Column
                    dataField="Address"
                    caption="상세주소"
                    alignment="center"
                  />
                  <Column
                    dataField="wDateTime"
                    caption="변경시간"
                    alignment="center"
                    customizeText={(cellData) =>
                      moment(cellData.value).utc().format('YYYY-MM-DD HH:mm:ss')
                    }
                  />
                </DataGrid>
              </div>
            ) : (
              <div>
                <div>
                  <DataGrid
                    className={'dx-card wide-card'}
                    columnAutoWidth={true}
                    dataSource={updateUserLimitInfoList}
                    focusedRowEnabled={true}
                    height="100%"
                    keyExpr="wDateTime"
                    noDataText="변경내역이 없습니다."
                    showBorders={true}
                    width="100%"
                  >
                    <Column
                      dataField="UseCheckValueText"
                      caption="한도"
                      alignment="center"
                    />
                    <Column
                      dataField="wDateTime"
                      caption="변경시간"
                      alignment="center"
                      customizeText={(cellData) =>
                        moment(cellData.value)
                          .utc()
                          .format('YYYY-MM-DD HH:mm:ss')
                      }
                    />
                  </DataGrid>
                </div>
              </div>
            )}
          </div>
          <div className="corp-list-update-info-bottom">
            <Button
              // className="normal-button"
              stylingMode="contained"
              type="normal"
              text="닫기"
              onClick={onHiding}
            />
          </div>
        </ScrollView>
      </Popup>
    </React.Fragment>
  );
};

export default React.memo(CorpListUpdateInfoPopup);
